
import { Box, Button, Grid, Hidden, MenuItem, Popover, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Container from '../../components/Container'
import { CountryCustom, TextFieldCustom } from '../../components/FormElements'
import Modal from '../../components/Modal'
import { config_path, portalCfg } from '../../router/config.path'
import validators from '../../utils/validators'
import PublicPage from '../PublicPage'
import { cache } from '../../utils/cache'
import { BackIcon } from '../../components/IconComponent'

export default function LoginWithPhoneView(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const appConfig = cache.getAppConfig();

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { calling_country_default, login_info, calling_country, calling_countries } = props;
    return (
        <PublicPage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showCRMLogo showLanguage useConfiguredLanguage>
            <Grid item xs={12}>
                <Grid item xs={12} marginTop={4}>
                    <Typography variant='h4' textAlign={'center'}>{appConfig && appConfig.name ? appConfig.name : t('btn_login')}</Typography>
                </Grid>
                <Grid item xs={12} marginTop={4}>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid item xs={12}>
                                    <Grid item xs={12} container alignItems={'center'}>
                                        <Grid item xs={4}>
                                            <Field
                                                name="calling_country"
                                                component={CountryCustom}
                                                isEdit={true}
                                                selectData={calling_countries}
                                                defaultValueSelect={calling_country_default ? calling_country_default.value : null}
                                                valueSelect={login_info && login_info.calling_country ? login_info.calling_country : calling_country_default.value}
                                                onSelectedChange={(event) => props.onSelectCountry('calling_country', event.target.value)}
                                                placeholder={t(' ')}
                                                // isHideLabel={windowWidth < 768 ? true : false}
                                                noMargin={true}
                                                onlyFlag={windowWidth < 768 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item xs={8} paddingLeft={1}>
                                            <Field
                                                name="phone_number"
                                                component={TextFieldCustom}
                                                placeholder={t('phone_input_placeholder')}
                                                isEdit={true}
                                                validate={validators.composeValidators(validators.required, validators.mustBeNumberRequired)}
                                                startAdorment={<Typography>{calling_country && calling_country.phone_code ? '+' + calling_country.phone_code : undefined}</Typography>}
                                            />
                                        </Grid>
                                    </Grid>
                                    {/* <Grid item xs={12} container justifyContent={'flex-end'}>
                                        <Button id='loginPhone/btnForgotPassword' onClick={() => navigate(config_path.forgot_password)} variant='text'>{t('forgot_password')}</Button>
                                    </Grid> */}
                                    <Grid item xs={12} marginY={3}>
                                        <Button id='loginPhone/btnSubmit' fullWidth size="large" variant='contained' onClick={handleSubmit} type='submit'>{t('btn_login')}</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    />
                </Grid>
                <Grid item xs={12} container alignItems={'center'} justifyContent={'center'} my={1}>
                    <Typography variant='subtitle2'>{t('dont_have_account')}</Typography>
                    <Button id='loginPhone/btnRegister' onClick={() => props.onRegister()} variant='text'>{t('btn_register')}</Button>
                </Grid>
            </Grid>
            {props.showRegisterAction && <Modal
                isOpen={props.showRegisterAction}
                onClose={() => props.setShowRegisterAction(false)}
                enableCloseButton
                title={t('btn_register')}
                width={{xs:"100%",md:"unset"}}
                height={{xs:"100vh",md:"unset"}}
                bottom={{xs:0,md:"unset"}}
                isHeader={true}
                borderRadius={{xs:0,md:"4px"}}
            >   
                 <Hidden mdUp>
                <Stack onClick={() => props.setShowRegisterAction(false)} direction={'row'} marginLeft={-2}   mb={3}>
                   <Stack style={{ cursor: 'pointer' }} >
                        <BackIcon />
                    </Stack>
                    
                </Stack>
                </Hidden>
                <Box>
                    <Stack direction={'row'}>
                        <Typography fontWeight={{xs:"bold",md:"unset"}} variant='caption' textAlign={'center'}>{t('exits_rewards_participant')}</Typography>
                    </Stack>
                    <Stack marginTop={4} direction={'row'} justifyContent={'center'} gap={2} alignItems={'center'}>
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <img src={portalCfg.publicPath + '/assets/images/register_have_card.png'} alt={'Logo Image'} height={150} />
                            <Button id='loginWithPhone/btnRegisterHaveCard' sx={{width:{xs:"100%",md:"unset"}}} onClick={() => navigate(config_path.register_existing_customer)} variant='outlined'>{t('btn_register_have_card')}</Button>
                        </Stack>
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <img src={portalCfg.publicPath + '/assets/images/register_new.png'} alt={'Logo Image'} height={150} />
                            <Button id='loginWithPhone/btnRegisterNew' sx={{width:{xs:"100%",md:"unset"}}} onClick={() => navigate(config_path.register)} variant='contained'>{t('btn_register_new')}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>}
        </PublicPage>
    )
}
